import api from "!../../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../mini-css-extract-plugin/dist/loader.js!../../../../css-loader/dist/cjs.js!../../../../postcss-loader/dist/cjs.js!./captions.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};